// extracted by mini-css-extract-plugin
export default {"wrapper":"providerSummarySlider_wrapper__t8hUc","slideWrapper":"providerSummarySlider_slideWrapper__4i7oM","slide":"providerSummarySlider_slide__4iwv6"};